import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';

import './form-item-mvno.component.scss';

export class FormItemMvno extends Base {

	form: HTMLFormElement;
	submitBtn: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = this.element.querySelector('.js-mvno__button');
	}

	bindEvents() {
		this.submitBtn.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.actionForm(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		});
	}

	actionForm(form: HTMLFormElement, loader: Element, thankyou: Element) {
		// additional containers
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');
		let name = Array.from(form.querySelectorAll('.form__success-container__firstname'));

		let postData = '';

		let _description: any = this.form.querySelector('input[name=description]');
		if (_description) {
			postData += '&description=' + _description.value;
		}

		let _firstName: any = this.form.querySelector('input[name=first-name]');
		if (_firstName) {
			postData += '&firstname=' + _firstName.value;
		}
		let _surname: any = this.form.querySelector('input[name=last-name]');
		if (_surname) {
			postData += '&surname=' + _surname.value;
		}
		let _contact: any = this.form.querySelector('input[name=contact-number]');
		if (_contact) {
			postData += '&contact=' + _contact.value;
		}
		let _identityNumber: any = this.form.querySelector('input[name=sa-identity-number]');
		if (_identityNumber) {
			postData += '&saId=' + _identityNumber.value;
		}

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/mvnoservice.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			loader.classList.remove('active');
			if (!response.data || (response.data.match(/(invalid)/gi))) {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
				error.classList.add('active');
				thankyou.classList.add('active');
				success.classList.remove('active');
			} else {
				analyticsService.dtmFormComplete('complete', response.code);
				thankyou.classList.add('active');
				success.classList.add('active');
				error.classList.remove('active');
				name.map((_item) => {
					_item.innerHTML = _firstName.value;
				});
			}
		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-mvno/form-item-mvno.component.ts